import React from 'react';
import { FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import { DashBoardIcon, StatsIcon } from '../../components/CustomIcon';

import '../../styles/Report.css';

const titleStyle = {
    fontFamily: 'NotoSans',
    fontSize: 30,
    fontWeight: 'bold',
    lineHeight: 1.17,
    letterSpacing: -0.17,
    color: '#000000',
};

const descriptionStyle = {
  objectFit: 'contain',
  fontFamily: 'NotoSans',
  fontSize: 18,
  lineHeight: 1.67,
  letterSpacing: -0.1,
  color: '#828282',
  margin: '24px auto 43px auto'
}

const NavExplainUI = ({icon, title, description}) => (
    <div style={{margin:'75px auto', display:'flex', justifyContent:'left', alignItems:'center'}}>
        <div style={{color:'#a202ff', width: 130, height: 130, background: 'rgba(162, 2, 255, 0.1)', padding: 40, borderRadius:75}}>
            {
                icon === 'dashboard' ? <DashBoardIcon/> : <StatsIcon />
            }
        </div>
        <div style={{textAlign:'left', marginLeft:36, width:330}}>
            <p style={{fontSize:25, fontWeight: 'bold', lineHeight: 0.8, letterSpacing: -0.01, color: '#3b3b3b', marginBottom: 10}}>
                <FormattedMessage id={title.id} defaultMessage={title.value}/>
            </p>
            <p style={{fontSize:15, lineHeight: 1.33, letterSpacing: -0.01, color: '#828282'}}>
                <FormattedHTMLMessage id={description.id} defaultMessage={description.value}/>
            </p>
        </div>
    </div>
)

const ComingSoon = () => (
    <div style={{textAlign: 'center', padding: '170px 0px'}}>
        <div style={{marginBottom:65}}>
            <div style={{backgroundColor: '#a202ff', width: 34, height: 4, margin:'auto'}}/>
            <div style ={{fontSize: 20, fontWeight: 'bold', lineHeight: 1.75, color:'#000', marginTop: 4}}>Report</div>
        </div>
        <div style={titleStyle}>
            <FormattedHTMLMessage
                id={'Report.title'}
                defaultMessage={'<span style="color:#a202ff;">스티커야…</span> 잘 있니?'}
                />
        </div>
        <div style={descriptionStyle}>
            <FormattedHTMLMessage
                id={'Report.description'}
                defaultMessage={'창작의 고통으로 낳은 내 소중한 스티커!<br/>어디서 어떻게 잘 크고 있는 궁금하셨죠?<br/><br/>아무도 안 알려주었던 <strong>내 스티커의 성장</strong>을<br/>스티커팜이 알려드립니다!'}
                />
        </div>
        <img src={require('../../img/report_preview_img@2x.png').default} alt="report_preview_img" style={{width: 386, marginBottom:61}}/>
        <div style={titleStyle}>
            <FormattedHTMLMessage
                id={'Report.ready.title'}
                defaultMessage={'그래서 <span style="color:#a202ff;">스티커팜</span>은<br/>이런걸 준비하고 있어요!'}
                />
        </div>
        <div style={{margin:'120px auto', width:'fit-content' }}>
            <NavExplainUI 
                icon="dashboard" 
                title={{ id: 'Report.dashbard.title', value: '대시보드' }}
                description={{id: 'Report.dashbard.description', value : '나에 대한 정보만 모았다!<br/>누구도 아닌, 오직 나만을 위한 꿀팁 대방출'}}
                />
            <NavExplainUI 
                icon="stats" 
                title={{ id: 'Report.stats.title', value: '통계 리포트' }}
                description={{id: 'Report.stats.description', value : '내 활동, 인기 스티커, 수익까지!<br/>스티커팜이 드리는 자세한 통계 리포트를 받아보세요.'}}
                />
        </div>
        <div style={titleStyle}><span role="img" aria-label="">✨ coming soon ✨</span></div>
        <div style={{fontSize: 18, lineHeight:1.94, letterSpacing: -0.1, color:'#828282', marginTop:129}}>
            <FormattedHTMLMessage
                id={'Report.cheering.message'}
                defaultMessage={'열심히 준비중인 스티커팜을 응원하신다면 <br/><strong>👇하트를 꾹 꾹👇</strong>'}
                />
        </div>
        <button
            className="heart"
            style={{backgroundPosition: window.localStorage.getItem("isClickedHeart") ? '-2800px 0px' : '0px 0px'}}
            onClick={ e => {
                if(!window.localStorage.getItem("isClickedHeart")){
                    window.localStorage.setItem("isClickedHeart", true);e.target.style.backgroundPosition = '-2800px 0px';
                }
            }}
        />
        <div style={{fontSize: 18, lineHeight:1.94, letterSpacing: -0.1, color:'#828282'}}>
            <FormattedHTMLMessage
                id={'Report.cheering.message.push'}
                defaultMessage={'<strong>👆눌러주세요!👆</strong>'}
            />
        </div>
    </div>
)

export default ComingSoon;